import React, {useEffect, useState, Fragment} from 'react';
import CUFormService from "../../../../services/CUFormService";
import {CHECK_IMG} from "../../../../constants";
import Color from "color";
import FormService from "../../../../services/FormsService";


const TemplateCUTaxe = (props) => {

    const cuFormService = new CUFormService();
    const [infoTaxes, setInfoTaxes] = useState();
    const fetchData = cuFormService.getData('taxe');

    useEffect(() => {
        if (fetchData) {
            setInfoTaxes(fetchData);
        }
    }, [fetchData]);

    // Helper functions to extract tax text based on layer
    const getTaxTxt = (layer, defaultValue) => {
        let out = infoTaxes?.find(item => item.layer === layer)?.txt || defaultValue;
        console.log("TemplateCUTaxe getTaxTxt", out)
        return out;
    };

    return (
        <div className="ue-section">
            <div className="text-left text-underline">
                <h3>ARTICLE 5 - Taxes</h3>
            </div>
                <p>
                    Les taxes suivantes pourront être exigées à compter de l'obtention d'un permis ou d'une décision de non opposition à une déclaration préalable :
                </p>
                <table className={'ue-form-table-row'} >
                    <thead>
                    <tr className={"ue-table-row-header"}>
                        <th style={{"width":"43px"}} className={'text-left'}>Catégorie</th>
                        <th className={'text-center'}>Description</th>
                        <th width={'20%'} className={'text-center'}>Taux</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>TA</td>
                            <td>Part de la taxe d’aménagement</td>
                            <td className={'text-right'}>
                                 { getTaxTxt("6501", "-") }
                            </td>
                        </tr>
                        <tr>
                            <td>TD</td>
                            <td>Part de la taxe départementale</td>
                            <td className={'text-right'}>
                            { getTaxTxt("6502", "-") }

                            </td>
                        </tr>
                        <tr>
                            <td>RAP</td>
                            <td>Part de redevance archéologique</td>
                            <td className={'text-right'}>
                            { getTaxTxt("6503", "-") }
                            </td>
                        </tr>

                    </tbody>
                </table>
            <br/>
            <br/>
       </div>
    );
};

export default TemplateCUTaxe;
